import React from 'react';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Characters from './screens/Characters';

function App() {
  return (
    <>
      <Navbar />
      <Characters />
      <Footer />
    </>
  );
}

export default App;
